import { getBranding, getDefaultDateSort, getThemeKey } from "@/config/branding";
export { getDefaultDateSort };

// 公共头部导航
export const PUBLIC_HEADER = [
  {
    name: "首页",
    path: "/",
  },
  {
    name: "版面检索",
    path: "/pageSearch",
  },
  {
    name: "全库检索",
    path: "/fullLibrary",
  },
  {
    name: "文章检索",
    path: "/articleSearch",
  },
  {
    name: "图片检索",
    path: "/photoSearch",
  },
  {
    name: "广告检索",
    path: "/adSearch",
  },
  {
    name: "检索统计",
    path: "/censusSearch",
  },
  {
    name: "专题列表",
    path: "/feature",
  },
];

// 日期排序
export const DATE_ORDER = [
  {
    label: "升序",
    value: "ASC",
    iconName: "el-icon-caret-top",
  },
  {
    label: "降序",
    value: "DESC",
    iconName: "el-icon-caret-bottom",
  },

];

// 时间筛选
export const TIME_RANGE = [
  {
    label: "全部(默认)",
    value: "",

  },
  {
    label: "最近7天",
    value: "1",
  },
  {
    label: "最近一个月",
    value: "2",
  },
  {
    label: "最近半年",
    value: "3",
  },
];

// 内容筛选
export const CONTENT_RANGE = [
  {
    label: "默认",
    value: "",
  },
  {
    label: "标题+内容",
    value: "titleContent",
  },
  {
    label: "标题",
    value: "newsTitle",
  },
  {
    label: "内容",
    value: "pureContent",
  },
  {
    label: "作者",
    value: "newsAuthor",
  },
  {
    label: "AI摘要",
    value: "aiArticleSummary",
  },
];

// 检索词之间的关系
export const LOGIC_SELECT = [
  {
    label: "AND",
    value: "0",
  },
  {
    label: "OR",
    value: "1",
  },
  {
    label: "NOT",
    value: "2",
  },
];

//体裁可选项
const GENRE_OPTIONAL = [
  {
    name: "消息",
    keyValue: "消息",
  },
  {
    name: "通讯",
    keyValue: "通讯",
  },
  {
    name: "社论",
    keyValue: "社论",
  },
  {
    name: "评论",
    keyValue: "评论",
  },
  {
    name: "讲话",
    keyValue: "讲话",
  },
  {
    name: "理论文章",
    keyValue: "理论文章",
  },
  {
    name: "来信",
    keyValue: "来信",
  },
  {
    name: "公报",
    keyValue: "公报",
  },
  {
    name: "公告",
    keyValue: "公告",
  },
  {
    name: "副刊文章",
    keyValue: "副刊文章",
  },
  {
    name: "专访访谈",
    keyValue: "专访访谈",
  },
  {
    name: "形象宣传",
    keyValue: "形象宣传",
  },
  {
    name: "其他",
    keyValue: "其他",
  },
];

// 可选的检索关键词 - 文章检索
export const ARTICLE_SEARCH = [
  {
    label: "标题",
    value: "newsTitle",
  },
  {
    label: "作者",
    value: "newsAuthor",
  },
  {
    label: "正文",
    value: "pureContent",
  },
  {
    label: "文章来源",
    value: "newsSource",
  },
  {
    label: "栏目",
    value: "newsColumns",
  },
  // {
  //   label: "专栏",
  //   value: "specialColumn",
  // },
  {
    label: "版名",
    value: "pageName",
  },
  {
    label: "版次",
    value: "pageNo",
  },
  {
    label: "期号",
    value: "paperIssue",
  },
  // {
  //   label: "AI体裁",
  //   value: "aiArticleGenre",
  //   selectItem: GENRE_OPTIONAL,
  // },
  // {
  //   label: "AI分类",
  //   value: "aiArticleClassification",
  // },
  // {
  //   label: "AI地区",
  //   value: "aiRegion",
  // },
  // {
  //   label: "AI专题列表",
  //   value: "aiTopic",
  // },
  // {
  //   label: "AI文章摘要",
  //   value: "aiArticleSummary",
  // },
  {
    label: "文章分类",
    value: "newsClassification",
  },
  {
    label: "文章体裁",
    value: "newsStyle",
    selectItem: GENRE_OPTIONAL,
  },
  {
    label: "地区",
    value: "newsRegion",
  },
  {
    label: "人物",
    value: "newsPerson",
  },
  {
    label: "头条",
    value: "isHead",
    selectItem: [
      {
        name: "是",
        keyValue: "是",
      },
      {
        name: "否",
        keyValue: "否",
      },
    ],
  },
  {
    label: "编辑姓名",
    value: "editPerson",
  },
  {
    label: "对外状态",
    value: "newIsSecret",
    selectItem: [
      {
        name: "是",
        keyValue: "是",
      },
      {
        name: "否",
        keyValue: "否",
      },
    ],
  },
];

// 可选的检索关键词 - 图库检索/图片检索
export const PHOTO_SEARCH = [
  {
    label: "标题",
    value: "newsTitle",
  },
  {
    label: "图片作者",
    value: "picAuthor",
  },
  {
    label: "图片来源",
    value: "picSource",
  },
  {
    // 用户手动输入（不提供固定下拉菜单）
    label: "图片说明123123",
    value: "memo",
  },
  //文汇包新增字段开始--------------------
  // {
  //   label: "图片体裁",
  //   value: "picStyle",
  // },
  // {
  //   label: "图片版权归属",
  //   value: "copyright",
  // },
  // {
  //   label: "创作地",
  //   value: "createLocation",
  // },
  // {
  //   label: "主题",
  //   value: "theme",
  // },
  // {
  //   label: "人物姓名",
  //   value: "personName",
  // },
  // {
  //   label: "画面主体",
  //   value: "mainSubject",
  // },
  // {
  //   label: "地点",
  //   value: "location",
  // },
  // {
  //   label: "事件",
  //   value: "event",
  // },
  // {
  //   label: "情景",
  //   value: "scene",
  // },
  // {
  //   label: "民族",
  //   value: "nation",
  // },
  // {
  //   label: "宗教",
  //   value: "religion",
  // },

  // {
  //   label: "专题",
  //   value: "specialTopic",
  // },
  //文汇包新增字段结束--------------------
  {
    label: " 栏目",
    value: "newsColumns",
  },
  {
    label: "版名",
    value: "pageName",
  },
  {
    label: "版次",
    value: "pageNum",
  },
  {
    label: "期号",
    value: "paperIssue",
  },
  // {
  //   label: "分类",
  //   value: "newsClassification",
  // },
  {
    label: "地区",
    value: "newsRegion",
  },
  {
    label: "人物",
    value: "newsPerson",
  },
  {
    label: "头条",
    value: "isHead",
    selectItem: [
      {
        name: "是",
        keyValue: "是",
      },
      {
        name: "否",
        keyValue: "否",
      },
    ],
  },
  {
    label: "对外状态",
    value: "newIsSecret",
    selectItem: [], // 动态从 DATA_AUTH 加载
  },
];

// 可选的检索关键词 - 广告检索
export const AD_SEARCH = [
  {
    label: "标题",
    value: "newsTitle",
  },
  {
    label: "广告关键词",
    value: "adKeyword",
  },
  {
    label: "广告色彩",
    value: "adColor",
    selectItem: [
      {
        name: "黑白广告",
        keyValue: "黑白广告",
      },
      {
        name: "套红广告",
        keyValue: "套红广告",
      },
      {
        name: "彩色广告",
        keyValue: "彩色广告",
      },
    ],
  },
  {
    label: "广告类型",
    value: "adType",
    selectItem: [
      {
        name: "工商广告",
        keyValue: "工商广告",
      },
      {
        name: "栏花广告",
        keyValue: "栏花广告",
      },
      {
        name: "专栏广告",
        keyValue: "专栏广告",
      },
      {
        name: "公益广告",
        keyValue: "公益广告",
      },
    ],
  },
  {
    label: "版名",
    value: "pageName",
  },
  {
    label: "版次",
    value: "pageNo",
  },
  {
    label: "期号",
    value: "paperIssue",
  },
  {
    label: "对外状态",
    value: "newIsSecret",
    selectItem: [
      {
        name: "是",
        keyValue: "是",
      },
      {
        name: "否",
        keyValue: "否",
      },
    ],
  },
];

// 可选的检索关键词 - 统计总记录数
export const RECORD_CENSUS = [
  {
    label: "标题",
    value: "newsTitle",
  },
  {
    label: "版次",
    value: "pageNoStr",
  },
  {
    label: "版名",
    value: "pageName",
  },
  {
    label: "期号",
    value: "paperIssue",
  },
  {
    label: "编辑姓名",
    value: "editPerson",
  },
  {
    label: "人物",
    value: "newsPerson",
  },
  {
    label: "地区",
    value: "newsRegion",
  },
  // {
  //   label: "体裁",
  //   value: "newsStyle",
  //   selectItem: GENRE_OPTIONAL,
  // },
];

// 可选检索词列表-统计版数
export const EDITION_CENSUS = [
  {
    label: "版名",
    value: "pageName",
  },
  {
    label: "版次",
    value: "pageNoStr",
  },
  // {
  //   label: '编辑姓名',
  //   value: 'newsPerson',
  // },
  // {
  //   label: '地区',
  //   value: 'newsRegion',
  // },
  // {
  //   label: '体裁',
  //   value: 'newsStyle',
  //   selectItem: GENRE_OPTIONAL
  // },
];

// 统计方法
export const STAT_WAY = [
  {
    label: "按年统计",
    value: "year",
  },
  {
    label: "按月统计",
    value: "month",
  },
  {
    label: "按日统计",
    value: "date",
  },
];

// 统计类型
export const STAT_TYPE = [
  {
    label: "统计总记录数",
    value: "DateTimeRangeQuery",
  },
  {
    label: "统计版数",
    value: "MatchPhraseQuery",
    statKey: "record",
  },
  {
    label: "统计文章篇数",
    value: "MatchPhraseQuery",
    statKey: "article",
  },
  {
    label: "统计图片数量",
    value: "MatchPhraseQuery",
    statKey: "picture",
  },
  {
    label: "统计广告数量",
    value: "MatchPhraseQuery",
    statKey: "ad",
  },
];

export const NEWS_TYPE = [
  {
    value: "文章",
    color: "#0056D2",
  },
  {
    value: "图片",
    color: "#EB6100",
  },
  {
    value: "广告",
    color: "#409eff",
  },
];

// 文章属性值
export const ARTICLE_ATTR = [
  { label: "栏目", propName: "newsColumns" },
  { label: "报名", propName: "paperName" },
  { label: "文章分类", propName: "newsClassification" },
  { label: "文章来源", propName: "newsSource" },
  { label: "文章字数", propName: "newsNumWords" },
  { label: "对外状态", propName: "newIsSecret" },
  { label: "头条", propName: "isHead" },
  { label: "文章体裁", propName: "newsStyle" },
  { label: "人物", propName: "newsPerson" },
  { label: "AI文章分类", propName: "aiArticleClassification" },
  { label: "AI文章体裁", propName: "aiArticleGenre" },
  { label: "AI地区", propName: "aiRegion" },
  { label: "AI专题列表", propName: "aiTopic" },
  { label: "AI文章摘要", propName: "aiArticleSummary" },
];

// 图片属性值
export const PHOTO_ATTR = [
  { label: "报名", propName: "paperName" },
  { label: "图片体裁", propName: "picStyle" },
  { label: "图片来源", propName: "picSource" },
  // { label: "图片作者", propName: "picAuthor" },
  { label: "新闻作者", propName: "newsAuthor" },
  { label: "栏目", propName: "newsColumns" },
  // { label: '头条', propName: 'isHead' },
  // { label: '人物', propName: 'newsPerson' },
  { label: "地区", propName: "newsRegion" },
  { label: "对外状态", propName: "newIsSecret" },
  // { label: '体裁', propName: 'newsStyle' },
];

// 广告属性
export const AD_ATTR = [
  {
    label: "报名",
    propName: "paperName",
  },
  // {
  //   label: '广告面积',
  //   propName: 'adArea',
  // },
  // {
  //   label: '广告色彩',
  //   propName: 'adColor',
  // },
  {
    label: "对外状态",
    propName: "newIsSecret",
  },
];

export const PAGE_SORT_NO = [
  {
    labelName: "第1版",
    value: "A1",
  },
  {
    labelName: "第2版",
    value: "B2",
  },
  {
    labelName: "第3版",
    value: "C3",
  },
  {
    labelName: "第4版",
    value: "D4",
  },
  {
    labelName: "第5版",
    value: "E5",
  },
  {
    labelName: "第6版",
    value: "F6",
  },
  {
    labelName: "第7版",
    value: "G7",
  },
  {
    labelName: "第8版",
    value: "H8",
  },
  {
    labelName: "第9版",
    value: "I9",
  },
  {
    labelName: "第10版",
    value: "J10",
  },
  {
    labelName: "第11版",
    value: "K11",
  },
  {
    labelName: "第12版",
    value: "L12",
  },
  {
    labelName: "第13版",
    value: "M13",
  },
  {
    labelName: "第14版",
    value: "N14",
  },
  {
    labelName: "第15版",
    value: "O15",
  },
  {
    labelName: "第16版",
    value: "P16",
  },
  {
    labelName: "第17版",
    value: "Q17",
  },
  {
    labelName: "第18版",
    value: "R18",
  },
  {
    labelName: "第19版",
    value: "S19",
  },
  {
    labelName: "第20版",
    value: "T20",
  },
  {
    labelName: "第21版",
    value: "U21",
  },
  {
    labelName: "第22版",
    value: "V22",
  },
  {
    labelName: "第23版",
    value: "W23",
  },
  {
    labelName: "第24版",
    value: "X24",
  },
  {
    labelName: "第25版",
    value: "Y25",
  },
  {
    labelName: "第26版",
    value: "Z26",
  },
];

export const ORDER_VALUE = [
  { label: "升序", value: "ASC" },
  { label: "降序", value: "DESC" },
];

/** 全库 / 筛选「报纸名称」复选框数据源（随构建主题切换；其他主题默认不配置报纸名称时为空） */
export const PAPER_COLL =
  getThemeKey() === "whb"
    ? [
      {
        label: "文汇报",
        value: "上海文汇报",
        imgSrc: "/home/whb/home/btn_whb.png",
      },
      {
        label: "新民晚报",
        value: "上海新民晚报",
        imgSrc: "/home/whb/home/btn_xmwb.png",
      },
      {
        label: "工人日报",
        value: "工人日报",
        imgSrc: "/home/whb/home/btn_grrb.png",
      },
      {
        label: "农民日报",
        value: "农民日报",
        imgSrc: "/home/whb/home/btn_nmrb.png",
      },
    ]
    : getThemeKey() === "hljrb"
      ? [
        {
          label: getBranding().paperMainName || "报纸",
          value: getBranding().paperMainName || "报纸",
          imgSrc: require("../image/home/paper_hljb.png"),
        },
        {
          label: "新黑龙江",
          value: "新黑龙江",
          imgSrc: require("../image/home/paper_xhlj.png"),
        },
        {
          label: "新黑龙江报",
          value: "新黑龙江报",
          imgSrc: require("../image/home/paper_xhljb.png"),
        },
        {
          label: "嫩江新报",
          value: "嫩江新报",
          imgSrc: require("../image/home/paper_ljxb.png"),
        },
        {
          label: "齐市新闻",
          value: "齐市新闻",
          imgSrc: require("../image/home/paper_qsxw.png"),
        },
        {
          label: "松江日报",
          value: "松江日报",
          imgSrc: require("../image/home/paper_sjb.png"),
        },
        {
          label: "合江日报",
          value: "合江日报",
        },
        {
          label: "黑龙江农民",
          value: "黑龙江农民",
        },
        {
          label: "松江农民",
          value: "松江农民",
        },
        {
          label: "松江日报农民版",
          value: "松江日报农民版",
        },
        {
          label: "嫩江电讯",
          value: "嫩江电讯",
        },
      ]
      : getThemeKey() === "fzrb"
        ? [
          {
            label: "法治日报",
            value: "法治日报",
            imgSrc: "/home/fzrb/home/paper_bz_fzrb.png",
          },
          {
            label: "法制日报社区版",
            value: "法制日报社区版",
            imgSrc: "/home/fzrb/home/paper_bz_fzrbsqb.png",
          },
          {
            label: "法治周末",
            value: "法治周末",
            imgSrc: "/home/fzrb/home/paper_bz_fzzm.png",
          },
          {
            label: "法治文化报",
            value: "法治文化报",
            imgSrc: "/home/fzrb/home/paper_bz_fzhb.png",
          },
          {
            label: "法治与新闻",
            value: "法治与新闻",
            imgSrc: "/home/fzrb/home/paper_qg_fzyxw.png",
          },
          {
            label: "法人FANRE",
            value: "法人FANRE",
            imgSrc: "/home/fzrb/home/paper_qg_fr.png",
          },
          {
            label: "法治参考",
            value: "法治参考",
            imgSrc: "/home/fzrb/home/paper_qg_fzck.png",
          },
        ]
        : getThemeKey() === "qpg"
          ? [
            {
              label: "工人日报",
              value: "工人日报",
            },
            {
              label: "农民日报",
              value: "农民日报",
            },
          ]
          : getThemeKey() === "bjrb"
            ? [
              {
                label: "抗敌报",
                value: "抗敌报",
              },
              {
                label: "北平解放报",
                value: "北平解放报",
              },
              {
                label: "人民日报北平版",
                value: "人民日报北平版",
              },
              {
                label: "北大清华联合报",
                value: "北大清华联合报",
              },
              {
                label: "工人周刊",
                value: "工人周刊",
              },
              {
                label: "京报",
                value: "京报",
              },
              {
                label: "解放",
                value: "解放",
              },
              {
                label: "劳动音",
                value: "劳动音",
              },
              {
                label: "每周评论",
                value: "每周评论",
              },
              {
                label: "新民报",
                value: "新民报",
              },
              {
                label: "前驱",
                value: "前驱",
              },
              {
                label: "新青年",
                value: "新青年",
              },
              {
                label: "政治生活",
                value: "政治生活",
              },
            ]
            : [];

/**
 * fzrb 专题：报纸名称 key → 附加查询 value（多对一）
 * 选中时同步勾选关联名称，取消时同步取消
 */
export const PAPER_EXTRA_VALUES =
  getThemeKey() === "fzrb"
    ? {
      法治日报: ["法制日报", "中国法制报"],
    }
    : {};

export const DEFAULT_PAPER_NAMES = [];

export const buildDefaultPaperSearchParams = (
  paperNames = DEFAULT_PAPER_NAMES,
  paperOptions = PAPER_COLL,
  extraValues = PAPER_EXTRA_VALUES,
) => {
  const names = Array.isArray(paperNames) ? paperNames : [];
  const primaryValues = paperOptions.map((item) => item.value);
  const collected = new Set();

  names.forEach((name) => {
    if (primaryValues.includes(name)) {
      collected.add(name);
      return;
    }
    Object.entries(extraValues).forEach(([key, extras]) => {
      if (extras.includes(name)) {
        collected.add(key);
      }
    });
  });

  const expanded = new Set();
  Array.from(collected).forEach((name) => {
    expanded.add(name);
    (extraValues[name] || []).forEach((value) => expanded.add(value));
  });

  return Array.from(expanded).map((name) => ({
    logicSelect: "1",
    selectOption: "paperName",
    input: name,
  }));
};

/**
 * 把当前报纸范围（顶部 NewspaperSelector 选中）合并进查询条件。
 * 直接透传报纸名（不经过 PAPER_COLL 过滤）：
 * eastview 主题下 PAPER_COLL 为空数组，选择器报纸名来自 searchAllProduct 的真实产品名，
 * 必须原样作为 paperName 条件下发。
 * - paperNames 为空：剔除 currentParams 中残留的 paperName 条件后返回（清空选择器后不再残留上一份报纸条件，空选 = 全库检索）
 * - paperNames 非空：剔除已有的 paperName 条件后，追加新的报纸范围
 */
export const buildPaperSearchParams = (currentParams = [], paperNames = []) => {
  const names = Array.isArray(paperNames) ? paperNames : [];
  // 始终先剔除旧报纸条件：即使本次范围为 空（选择器被清空），也不能把上一次的 paperName 条件带入查询
  const rest = currentParams.filter((p) => p && p.selectOption !== "paperName");
  if (names.length === 0) return rest;
  const paperParams = names.map((name) => ({
    logicSelect: "1",
    selectOption: "paperName",
    input: name,
  }));
  return [...rest, ...paperParams];
};


/**
 * 主题判断统一入口：判断当前构建是否属于某个主题系
 *
 * 主题名唯一来源是环境变量 VUE_APP_HOME_THEME（经 getThemeKey() 归一化：去空格 + 转小写）。
 * 两条命中路径：
 * 1. 自身主题键等于 name        —— 如 VUE_APP_HOME_THEME='eastview'
 * 2. branding.baseTheme 等于 name —— 如 qiushi 声明 baseTheme='eastview'
 *
 * 派生客户只需在 branding 里声明 baseTheme，无需在每处判断追加 || 链。
 * @param {string} name - 主题名
 * @returns {boolean}
 */
function matchesTheme(name) {
  return getThemeKey() === name || getBranding().baseTheme === name;
}

export function isShzbsh() {
  return matchesTheme("shzbsh");
}

/**
 * 是否属于 eastview 系（eastview 本身 + 其派生客户，如 qiushi）
 * 影响范围：App.vue 的 Header/TopNavBar 与 Footer 渲染分支
 */
export function isEastView() {
  return matchesTheme("eastview");
}